/**
 * 此文件由 build-plugins.ts 自动生成
 * 请勿手动修改
 * Generated at: 2025-12-29T15:48:59.295Z
 */

import { lazy, ComponentType } from 'react';
import type { PluginRegistry, SidebarMenuItem } from '@kernel/core/plugin-loader';

import track_managerPlugin from '@plugins/track-manager/frontend';
import team_collabPlugin from '@plugins/team-collab/frontend';
import schedulerPlugin from '@plugins/scheduler/frontend';
import content_managerPlugin from '@plugins/content-manager/frontend';
import competitor_analyzerPlugin from '@plugins/competitor-analyzer/frontend';
import cluster_managerPlugin from '@plugins/cluster-manager/frontend';
import analyticsPlugin from '@plugins/analytics/frontend';
import ai_studioPlugin from '@plugins/ai-studio/frontend';
import account_managerPlugin from '@plugins/account-manager/frontend';

/**
 * 注册所有插件
 */
export function registerPlugins(registry: PluginRegistry): void {
  registry.register(track_managerPlugin);
  registry.register(team_collabPlugin);
  registry.register(schedulerPlugin);
  registry.register(content_managerPlugin);
  registry.register(competitor_analyzerPlugin);
  registry.register(cluster_managerPlugin);
  registry.register(analyticsPlugin);
  registry.register(ai_studioPlugin);
  registry.register(account_managerPlugin);
}

/**
 * 静态侧边栏菜单配置
 */
export const staticSidebarMenus: SidebarMenuItem[] = [
  {
    id: 'track-manager',
    title: '赛道管理',
    icon: 'target',
    path: '/tracks',
    order: 3,
  },
  {
    id: 'team-collab',
    title: '团队协作',
    icon: 'user-cog',
    path: '/team',
    order: 8,
  },
  {
    id: 'scheduler',
    title: '排期调度',
    icon: 'calendar',
    path: '/schedule',
    order: 7,
  },
  {
    id: 'content-manager',
    title: '内容管理',
    icon: 'file-text',
    path: '/content',
    order: 2,
  },
  {
    id: 'competitor-analyzer',
    title: '竞品分析',
    icon: 'telescope',
    path: '/competitors',
    order: 4,
  },
  {
    id: 'cluster-manager',
    title: '集群管理',
    icon: 'server',
    path: '/clusters',
    order: 5,
  },
  {
    id: 'analytics',
    title: '数据分析',
    icon: 'bar-chart',
    path: '/analytics',
    order: 6,
  },
  {
    id: 'ai-studio',
    title: 'AI工作室',
    icon: 'sparkles',
    path: '/ai-studio',
    order: 9,
  },
  {
    id: 'account-manager',
    title: '账号管理',
    icon: 'users',
    path: '/accounts',
    order: 1,
  }
];

/**
 * 静态路由配置
 */
export interface StaticRoute {
  path: string;
  element: ComponentType;
}

export const staticRoutes: StaticRoute[] = [
  {
    path: '/tracks',
    element: lazy(() => import('@plugins/track-manager/frontend/pages/TrackList').then(m => ({ default: m.TrackList || m.default }))),
  },
  {
    path: '/tracks/new',
    element: lazy(() => import('@plugins/track-manager/frontend/pages/TrackEditor').then(m => ({ default: m.TrackEditor || m.default }))),
  },
  {
    path: '/tracks/:id',
    element: lazy(() => import('@plugins/track-manager/frontend/pages/TrackDetail').then(m => ({ default: m.TrackDetail || m.default }))),
  },
  {
    path: '/tracks/:id/keywords',
    element: lazy(() => import('@plugins/track-manager/frontend/pages/KeywordLibrary').then(m => ({ default: m.KeywordLibrary || m.default }))),
  },
  {
    path: '/tracks/trends',
    element: lazy(() => import('@plugins/track-manager/frontend/pages/TrendAnalysis').then(m => ({ default: m.TrendAnalysis || m.default }))),
  },
  {
    path: '/team',
    element: lazy(() => import('@plugins/team-collab/frontend/pages/TeamMembers').then(m => ({ default: m.TeamMembers || m.default }))),
  },
  {
    path: '/team/roles',
    element: lazy(() => import('@plugins/team-collab/frontend/pages/RoleManagement').then(m => ({ default: m.RoleManagement || m.default }))),
  },
  {
    path: '/team/tasks',
    element: lazy(() => import('@plugins/team-collab/frontend/pages/TaskBoard').then(m => ({ default: m.TaskBoard || m.default }))),
  },
  {
    path: '/team/logs',
    element: lazy(() => import('@plugins/team-collab/frontend/pages/AuditLogs').then(m => ({ default: m.AuditLogs || m.default }))),
  },
  {
    path: '/schedule',
    element: lazy(() => import('@plugins/scheduler/frontend/pages/ScheduleCalendar').then(m => ({ default: m.ScheduleCalendar || m.default }))),
  },
  {
    path: '/schedule/queue',
    element: lazy(() => import('@plugins/scheduler/frontend/pages/PublishQueue').then(m => ({ default: m.PublishQueue || m.default }))),
  },
  {
    path: '/schedule/history',
    element: lazy(() => import('@plugins/scheduler/frontend/pages/PublishHistory').then(m => ({ default: m.PublishHistory || m.default }))),
  },
  {
    path: '/content',
    element: lazy(() => import('@plugins/content-manager/frontend/pages/ContentList').then(m => ({ default: m.ContentList || m.default }))),
  },
  {
    path: '/content/new',
    element: lazy(() => import('@plugins/content-manager/frontend/pages/ContentEditor').then(m => ({ default: m.ContentEditor || m.default }))),
  },
  {
    path: '/content/:id/edit',
    element: lazy(() => import('@plugins/content-manager/frontend/pages/ContentEditor').then(m => ({ default: m.ContentEditor || m.default }))),
  },
  {
    path: '/content/templates',
    element: lazy(() => import('@plugins/content-manager/frontend/pages/TemplateList').then(m => ({ default: m.TemplateList || m.default }))),
  },
  {
    path: '/content/assets',
    element: lazy(() => import('@plugins/content-manager/frontend/pages/AssetLibrary').then(m => ({ default: m.AssetLibrary || m.default }))),
  },
  {
    path: '/competitors',
    element: lazy(() => import('@plugins/competitor-analyzer/frontend/pages/CompetitorList').then(m => ({ default: m.CompetitorList || m.default }))),
  },
  {
    path: '/competitors/add',
    element: lazy(() => import('@plugins/competitor-analyzer/frontend/pages/CompetitorAdd').then(m => ({ default: m.CompetitorAdd || m.default }))),
  },
  {
    path: '/competitors/:id',
    element: lazy(() => import('@plugins/competitor-analyzer/frontend/pages/CompetitorDetail').then(m => ({ default: m.CompetitorDetail || m.default }))),
  },
  {
    path: '/competitors/compare',
    element: lazy(() => import('@plugins/competitor-analyzer/frontend/pages/CompetitorCompare').then(m => ({ default: m.CompetitorCompare || m.default }))),
  },
  {
    path: '/competitors/reports',
    element: lazy(() => import('@plugins/competitor-analyzer/frontend/pages/CompetitorReports').then(m => ({ default: m.CompetitorReports || m.default }))),
  },
  {
    path: '/clusters',
    element: lazy(() => import('@plugins/cluster-manager/frontend/pages/ClusterDashboard').then(m => ({ default: m.ClusterDashboard || m.default }))),
  },
  {
    path: '/clusters/new',
    element: lazy(() => import('@plugins/cluster-manager/frontend/pages/ClusterCreate').then(m => ({ default: m.ClusterCreate || m.default }))),
  },
  {
    path: '/clusters/:id',
    element: lazy(() => import('@plugins/cluster-manager/frontend/pages/ClusterDetail').then(m => ({ default: m.ClusterDetail || m.default }))),
  },
  {
    path: '/clusters/:id/tasks',
    element: lazy(() => import('@plugins/cluster-manager/frontend/pages/TaskQueue').then(m => ({ default: m.TaskQueue || m.default }))),
  },
  {
    path: '/clusters/monitoring',
    element: lazy(() => import('@plugins/cluster-manager/frontend/pages/MonitoringCenter').then(m => ({ default: m.MonitoringCenter || m.default }))),
  },
  {
    path: '/analytics',
    element: lazy(() => import('@plugins/analytics/frontend/pages/AnalyticsDashboard').then(m => ({ default: m.AnalyticsDashboard || m.default }))),
  },
  {
    path: '/analytics/accounts',
    element: lazy(() => import('@plugins/analytics/frontend/pages/AccountAnalytics').then(m => ({ default: m.AccountAnalytics || m.default }))),
  },
  {
    path: '/analytics/content',
    element: lazy(() => import('@plugins/analytics/frontend/pages/ContentAnalytics').then(m => ({ default: m.ContentAnalytics || m.default }))),
  },
  {
    path: '/analytics/trends',
    element: lazy(() => import('@plugins/analytics/frontend/pages/TrendAnalytics').then(m => ({ default: m.TrendAnalytics || m.default }))),
  },
  {
    path: '/analytics/reports',
    element: lazy(() => import('@plugins/analytics/frontend/pages/ReportCenter').then(m => ({ default: m.ReportCenter || m.default }))),
  },
  {
    path: '/ai-studio',
    element: lazy(() => import('@plugins/ai-studio/frontend/pages/AIStudio').then(m => ({ default: m.AIStudio || m.default }))),
  },
  {
    path: '/ai-studio/generator',
    element: lazy(() => import('@plugins/ai-studio/frontend/pages/ContentGenerator').then(m => ({ default: m.ContentGenerator || m.default }))),
  },
  {
    path: '/ai-studio/analyzer',
    element: lazy(() => import('@plugins/ai-studio/frontend/pages/HotContentAnalyzer').then(m => ({ default: m.HotContentAnalyzer || m.default }))),
  },
  {
    path: '/ai-studio/assistant',
    element: lazy(() => import('@plugins/ai-studio/frontend/pages/WritingAssistant').then(m => ({ default: m.WritingAssistant || m.default }))),
  },
  {
    path: '/accounts',
    element: lazy(() => import('@plugins/account-manager/frontend/pages/AccountList').then(m => ({ default: m.AccountList || m.default }))),
  },
  {
    path: '/accounts/new',
    element: lazy(() => import('@plugins/account-manager/frontend/pages/AccountNew').then(m => ({ default: m.AccountNew || m.default }))),
  },
  {
    path: '/accounts/:id',
    element: lazy(() => import('@plugins/account-manager/frontend/pages/AccountDetail').then(m => ({ default: m.AccountDetail || m.default }))),
  },
  {
    path: '/accounts/groups',
    element: lazy(() => import('@plugins/account-manager/frontend/pages/AccountGroups').then(m => ({ default: m.AccountGroups || m.default }))),
  }
];
